import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "info" }, "Dieser Dienst wird ausschliesslich für den Bildungsbereich in der Schweiz angeboten.", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_MainSection = _resolveComponent("MainSection")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header),
    _createElementVNode("main", null, [
      _createVNode(_component_MainSection, { content: _ctx.content }, null, 8, ["content"])
    ]),
    _hoisted_1,
    _createVNode(_component_Footer)
  ], 64))
}